<template>
  <layout-legacy-component>
    <breadcrumb-component/>
    <section class="cart">
      <template v-if="objects.length">
        <desktop-component
          :objects="objects"
          :report-type="reportType"
          :paper-report-price="paperReportPrice"
          :delete-cart-item-handler="deleteCartItemHandler"
          :change-report-type-handler="changeReportTypeHandler"
          :price="orderPrice"
        />
        <mobile-component
          :objects="objects"
          :report-type="reportType"
          :paper-report-price="paperReportPrice"
          :delete-cart-item-handler="deleteCartItemHandler"
          :change-report-type-handler="changeReportTypeHandler"
          :price="orderPrice"
        />
      </template>
      <template v-else>
        <div class="align-center">Корзина пуста</div>
      </template>
    </section>
  </layout-legacy-component>
</template>

<script>
import { watchEffect, computed } from "vue";
import { useStore } from "vuex";
import { useToaster } from "../../services/hooks";
import { useState } from "../../services/hooks";
import { CART_DROP_ITEM_BY_INDEX, CART_EDIT_FIELDS, CART_GET_CART_DEFAULT } from "../../store/constants";
import LayoutLegacyComponent from "../../layouts/LayoutLegacy";
import BreadcrumbComponent from "../../components/BreadcrumbComponent";
import DesktopComponent from "./DesktopComponent.vue";
import MobileComponent from "./MobileComponent.vue";

export default {
    name: 'CartView',
    components: {
      LayoutLegacyComponent,
      BreadcrumbComponent,
      DesktopComponent,
      MobileComponent
    },
    setup() {

      const store = useStore();
      const reportType = computed(() => store.getters[CART_GET_CART_DEFAULT].type);
      const cartObjectItems = computed(() => store.getters[CART_GET_CART_DEFAULT].items);
      const paperReportPrice = store.state.pricePaperReport;

      const [objects, setObjects] = useState([]);
      const [orderPrice, setOrderPrice] = useState(0);

      const { alertSuccess } = useToaster();

      const initCart = () => {

        let price = 0;

        const objects = cartObjectItems.value.map(storeCartItem => {
          const object = store.getters.findObjectById(storeCartItem.id);
          object.dbIndex = storeCartItem.index;
          if(object.priceSale) {
            price += object.priceSale;
          } else {
            price += object.price;
          }
          object.page = store.getters.getPageByObject(object.id);
          return object;
        });

        if(reportType.value === 2) {
          price += (paperReportPrice*cartObjectItems.value.length);
        }

        setOrderPrice(price);
        setObjects(objects);
      };

      const deleteCartItemHandler = (itemIndex) => {
        store.dispatch(CART_DROP_ITEM_BY_INDEX, itemIndex);
        alertSuccess('Успешно удалено из корзины');
      };

      const changeReportTypeHandler = () => {
        if(!reportType.value || reportType.value === 1) {
          store.dispatch(CART_EDIT_FIELDS, { index: 'type', value: 2 });
        } else {
          store.dispatch(CART_EDIT_FIELDS, { index: 'type', value: 1 });
        }
      };

      watchEffect(initCart);

      return {
        objects,
        orderPrice,
        paperReportPrice,
        reportType,
        deleteCartItemHandler,
        changeReportTypeHandler
      }
    }
};
</script>

<style scoped>

</style>
